var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUdhaar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 15C3.60218 15 3.22064 15.158 2.93934 15.4393C2.65804 15.7206 2.5 16.1022 2.5 16.5C2.5 17.0523 2.05228 17.5 1.5 17.5C0.947715 17.5 0.5 17.0523 0.5 16.5C0.5 15.5717 0.868749 14.6815 1.52513 14.0251C2.1815 13.3687 3.07174 13 4 13H16.5C17.0523 13 17.5 13.4477 17.5 14C17.5 14.5523 17.0523 15 16.5 15H4Z",
    fill: "#8993A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 2C3.60218 2 3.22064 2.15804 2.93934 2.43934C2.65804 2.72064 2.5 3.10218 2.5 3.5V16.5C2.5 16.8978 2.65804 17.2794 2.93934 17.5607C3.22064 17.842 3.60218 18 4 18H15.5V2H4ZM1.52513 1.02513C2.1815 0.368749 3.07174 0 4 0H16.5C17.0523 0 17.5 0.447715 17.5 1V19C17.5 19.5523 17.0523 20 16.5 20H4C3.07174 20 2.1815 19.6313 1.52513 18.9749C0.868749 18.3185 0.5 17.4283 0.5 16.5V3.5C0.5 2.57174 0.868749 1.6815 1.52513 1.02513Z",
    fill: "#8993A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUdhaar);
export default __webpack_public_path__ + "static/media/udhaar.078caebcb5042fb6f3d47341fea56c88.svg";
export { ForwardRef as ReactComponent };